import React, { useContext } from 'react';
import { Box, Container } from '@material-ui/core';
import { observer } from 'mobx-react';

import { isDesktop as isDesktopView } from './functions/isDesktop';
import { Matrix } from './components/Matrix/Matrix';
import './styles/App.scss';
import { Sidebar } from './components/Sidebar/Sidebar';
import RootStoreContext from './storage/RootStore';
import { AlignmentsList } from './storage/Debugging';


const App = observer(() => {
  const isDesktop = isDesktopView();
  const { selection, dataset, dimensions, debugging } = useContext(RootStoreContext)

  return (
    <div className="app reset">
      {process.env.NODE_ENV === 'development' && <><div style={{ position: 'fixed', top: '0px', padding: '0 20px', minWidth: '100px', fontSize: '12px' }}>
        <p>org: {selection.org}</p>
        <p>stage: {selection.stage}</p>
        <p>doc: {selection.doc}</p>
        <p>problem: {selection.problem}</p>
        <p>orgStage: {selection.orgStage}</p>
        <p>view: {selection.view}</p>
        <p>align: {debugging.alignment}</p>
      </div>
      <div style={{position: 'absolute'}}>
          {AlignmentsList
            .map(option => <button key={option} onClick={() => debugging.setAlignment(option)}>{option}</button>)}
      </div>
      </>}
     
      <div className={'main reset'}>
        <Container disableGutters={true} maxWidth={'xl'} className={'reset'} style={{ overflowX: isDesktop ? 'unset' : 'auto', display: 'flex', justifyContent: 'space-between' }}>
          <Box style={{ width: dimensions.WIDTH_MATRIX, height: dimensions.HEIGHT_MATRIX_AREA }}>
            <Matrix style={{ display: 'block' }} isDesktop={isDesktop} />
          </Box>

          <Sidebar />

        </Container>
      </div>
    </div>
  );
})

export default App;